module.exports = __webpack_public_path__ + "img/img_index_zi_guanli@2x.c803a9d3.png";